var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitorList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.143555,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_23899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 19C23.88 19 24.99 17.88 24.99 16.5C24.99 15.12 23.88 14 22.5 14C21.12 14 20 15.12 20 16.5C20 17.88 21.12 19 22.5 19ZM15 18C16.66 18 17.99 16.66 17.99 15C17.99 13.34 16.66 12 15 12C13.34 12 12 13.34 12 15C12 16.66 13.34 18 15 18ZM22.5 21C20.67 21 17 21.92 17 23.75V26H28V23.75C28 21.92 24.33 21 22.5 21ZM15 20C12.67 20 8 21.17 8 23.5V26H15V23.75C15 22.9 15.33 21.41 17.37 20.28C16.5 20.1 15.66 20 15 20Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_23899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitorList);
export default __webpack_public_path__ + "static/media/competitorList.d1aa7933d1bf1c115d7bc8964ba813e2.svg";
export { ForwardRef as ReactComponent };